import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
import moment from 'moment';
import AutoNumeric from 'autonumeric';
var History = {
  pn: 'div[data-name=history]',
  page: 0,
  limit: 20,
  currentDisplay: 0,
  allowInfinite: true,
  hasMoreItems: true,
  totalItems: 0,
  init: function init() {
    var self = this;
    self.page = 0;
    self.currentDisplay = 0;
    self.allowInfinite = true;
    self.hasMoreItems = true;
    Base.historyItems = new Map();
    self.list();
    $(self.pn + ' .infinite-scroll-content').on('infinite', function () {
      if (!self.allowInfinite) return;
      self.allowInfinite = false;
      self.page += 1;
      self.list();
    });
  },
  list: function () {
    var _list = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var self, rs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = this;
              _context.next = 3;
              return Base.api('Donhangdat', 'list', {
                page: self.page,
                limit: self.limit
              });

            case 3:
              rs = _context.sent;
              self.totalItems = rs.total;

              if (!(rs.rows.length == 0)) {
                _context.next = 8;
                break;
              }

              $(self.pn + ' .infinite-scroll-preloader').addClass('display-none');
              return _context.abrupt("return");

            case 8:
              self.currentDisplay += rs.rows.length;
              self.allowInfinite = true;
              rs.rows.forEach(function (item, i) {
                $(self.pn + ' .history-list').append("<li><a href=\"/history-popup/".concat(item.id, "\">ID-").concat(item.id, ". ").concat(moment(item.order_date).format(Base.dateTimeFormat), " (").concat(Base.donHangDatStatus[Utils.str2Num(item.status)], ")</a></li>"));
                Base.historyItems.set(item.id, item);
              });
              if (self.currentDisplay == self.totalItems || self.currentDisplay > self.totalItems) $(self.pn + ' .infinite-scroll-preloader').addClass('display-none');else $(self.pn + ' .infinite-scroll-preloader').removeClass('display-none');

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function list() {
      return _list.apply(this, arguments);
    }

    return list;
  }()
};
export default (function ($prop, ctx) {
  ctx.$on('pageInit', function () {
    History.init();
  });

  var profile = function profile() {
    Base.profile();
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="history">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left"></div>
        <div class="title sliding">Lịch sử đặt hàng</div>
        <div class="right"><a href="#" @click=${profile}><i class="f7-icons icon">person_circle</i></a></div>
      </div>
    </div>
    <div class="page-content infinite-scroll-content infinite-scroll-bottom">
      <div class="list links-list no-margin">
        <ul class="history-list">

        </ul>
        <div class="preloader infinite-scroll-preloader"></div>
      </div>
    </div>
  </div>
`
    }
    ;
});